import * as React from 'react';
import { Container, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { TRY_IN_STORE_MAX_PRODUCTS } from '../../configuration/storage.js';
import { pushTryOnInStoreEvent } from '../../data-layer/try-on-in-store.js';
import { useTryInStore } from '../../hooks/use-try-in-store.js';
import { SelectionModal } from '../SelectionModal/SelectionModal.js';

const BannerComponent = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [{ itemCount  }] = useTryInStore();
    const itemsLabel = getFormattedLabel(`tryInStore.component.banner.itemCount`, {
        labelData: {
            itemCount,
            maxItems: TRY_IN_STORE_MAX_PRODUCTS
        }
    });
    const [showModal, setShowModal] = React.useState(false);
    const onClickShowModal = React.useCallback(()=>{
        pushTryOnInStoreEvent({
            interactionType: 'view_items_list'
        });
        setShowModal(true);
    }, [
        setShowModal
    ]);
    const onModalClose = React.useCallback(()=>{
        setShowModal(false);
    }, [
        setShowModal
    ]);
    // We don't want to return null inside this component if there are no items, that's why we keep the wrapper div
    // React doesn't render this component in the right way when we do so (Local Storage & SSR)
    return /*#__PURE__*/ React.createElement("div", {
        className: "try-in-store-banner"
    }, itemCount ? /*#__PURE__*/ React.createElement("div", {
        className: "try-in-store-banner__wrapper"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("button", {
        onClick: onClickShowModal,
        className: "try-in-store-banner__button"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "try-in-store-banner__content"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "store"
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        component: "span"
    }, getLabel('tryInStore.component.banner.title')), /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, "\xa0", itemsLabel)), /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right",
        className: "try-in-store-banner__chevron"
    }))))) : null, showModal ? /*#__PURE__*/ React.createElement(SelectionModal, {
        onModalClose: onModalClose
    }) : null);
};
const Banner = ()=>{
    const { isTryInStoreEnabled  } = useFeatureToggles();
    if (isTryInStoreEnabled) {
        return /*#__PURE__*/ React.createElement(BannerComponent, null);
    }
    return null;
};

export { Banner };
//# sourceMappingURL=Banner.js.map
